import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type OutsideBoundaryWarningDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
};

export const OutsideBoundaryWarningDialog = ({ open, onOpenChange, onContinue }: OutsideBoundaryWarningDialogProps) => (
  <AlertDialog
    open={open}
    onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Annotation outside boundary</AlertDialogTitle>
        <AlertDialogDescription>
          This annotation is outside the area used during capture. If you continue, it will affect counts, derived
          density, and exports when you save.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onContinue}>Continue Anyway</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
